export const toggleWelcome = () => {
  return(dispatch, getState) => {
    const showWelcome = getState().ux.showWelcome
    if (showWelcome) {
      dispatch({type: 'HIDE_WELCOME'});
    } else {
      dispatch({type: 'SHOW_WELCOME'});
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/ux.js